import { FC, ReactNode } from 'react'
import { StyleSheet } from 'react-native'
import { Divider, List } from 'react-native-paper'
import { ColorsEnum } from '../../constants/colors'

interface DividedListProps {
    upperItems: ReactNode[]
    lowerItems: ReactNode[]
}

const DividedList: FC<DividedListProps> = ({ upperItems, lowerItems }) => {
    const isDivider = upperItems.length > 0 && lowerItems.length > 0

    return (
        <List.Section style={styles.container}>
            {upperItems}
            {isDivider && <Divider style={styles.divider} />}
            {lowerItems}
        </List.Section>
    )
}

const styles = StyleSheet.create({
    container: {
        marginVertical: 0,
        paddingHorizontal: 6,
    },
    divider: {
        backgroundColor: ColorsEnum.GRAY,
        height: 3,
    },
})

export default DividedList
